"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionManager = void 0;
exports.genUuid = genUuid;
const SESSION_TTL_MS = 30 * 60 * 1000;
function genUuid() {
    const g = globalThis;
    if (g.crypto && typeof g.crypto.randomUUID === 'function') {
        return g.crypto.randomUUID();
    }
    // Manual RFC4122 v4 from crypto.getRandomValues — broader support than
    // randomUUID, and crypto-secure. Should cover essentially every runtime
    // where randomUUID is missing.
    if (g.crypto && typeof g.crypto.getRandomValues === 'function') {
        const bytes = new Uint8Array(16);
        g.crypto.getRandomValues(bytes);
        bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
        bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10xx
        const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
        return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
    }
    // Last-resort fallback. Not cryptographically secure, but the branch
    // should be unreachable in any supported runtime (modern browsers,
    // Node ≥14.17, RN Hermes ≥0.70). Warn so we notice if it ever fires.
    // eslint-disable-next-line no-console
    console.warn('[analytics] crypto API unavailable; falling back to Math.random for UUIDs');
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
class SessionManager {
    constructor() {
        this.sessionId = genUuid();
        this.lastActiveAt = Date.now();
    }
    getSessionId() {
        this.lastActiveAt = Date.now();
        return this.sessionId;
    }
    /** Returns true if a new session was started due to idle timeout. */
    touch() {
        const now = Date.now();
        const rotated = now - this.lastActiveAt > SESSION_TTL_MS;
        if (rotated) {
            this.sessionId = genUuid();
        }
        this.lastActiveAt = now;
        return rotated;
    }
    reset() {
        this.sessionId = genUuid();
        this.lastActiveAt = Date.now();
    }
}
exports.SessionManager = SessionManager;
